module.exports = __webpack_public_path__ + "img/IAR18.ffd72633.png";